import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { createRoot } from 'react-dom/client';

import App from '@/App';
import { createReactRootOptions, initSentry } from '@/infrastructure/errorHandler';
import Firebase from '@/services/firebase.service';

import './index.css';
import ApolloProvider from '@/services/graphql/ApolloProvider';
import theme from '@/styles/theme';

import { initI18Next } from './modules/common/application/i18n';
import { FirebaseProvider } from './modules/common/application/Provider/Firebase';
import { MessageProvider } from './modules/common/application/Provider/Message';
import { UserProvider } from './modules/common/application/Provider/User';
import { loginWithToken } from './services/auth.service';

declare global {
  let __rootdir__: string;
}

initSentry();
initI18Next();

// expose helper for Playwright
window.loginWithToken = loginWithToken;

// ---------------------------------------------------------------- Firebase & i18n
const firebase = new Firebase();
const graphqlEndpoint = import.meta.env.VITE_GQL_ENDPOINT as string;
const rootElement = document.getElementById('root');

if (rootElement === null) {
  throw new Error('Root element #root was not found');
}

createRoot(rootElement, createReactRootOptions()).render(
  <ThemeProvider theme={theme}>
    <FirebaseProvider firebase={firebase}>
      <ApolloProvider firebase={firebase} graphqlEndpoint={graphqlEndpoint}>
        <UserProvider>
          <MessageProvider>
            <CssBaseline />
            <App />
          </MessageProvider>
        </UserProvider>
      </ApolloProvider>
    </FirebaseProvider>
  </ThemeProvider>
);
